const Skills = () => {
    const skills = ["Javascript", "Typescript", "PHP", "React JS", "Next JS", "Laravel", "Tailwind CSS", "Bootstrap", "Node JS", "MySQL", "Git", "GitHub", "Docker", "Linux", "RESTful API", "Figma"];

    return (
        <div className="border-b-2 border-black py-4 overflow-hidden bg-black">
            <div className="marquee-track">
                {[...skills, ...skills].map((skill, index) => (
                    <span
                        key={index}
                        className="inline-flex items-center gap-6 px-6 whitespace-nowrap text-primary text-lg font-semibold"
                    >
                        {skill}
                        <span className="text-white text-lg">✦</span>
                    </span>
                ))}
            </div>
        </div>
    )
}

export default Skills